import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { I18nService } from '../core/services/i18n.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  template: `
    <aside class="sidebar">
      <div class="brand">{{ i18n.t('app.name') }}</div>
      <nav>
        <a routerLink="/dashboard" routerLinkActive="active">{{ i18n.t('sidebar.dashboard') }}</a>
        <a routerLink="/archive" routerLinkActive="active">{{ i18n.t('sidebar.archive') }}</a>
        <a routerLink="/admin" routerLinkActive="active">{{ i18n.t('sidebar.admin') }}</a>
      </nav>
    </aside>
  `,
  styles: [`
    .sidebar { width: 240px; background:#1f2937; color:#fff; min-height:100vh; padding:24px 16px; }
    .brand { font-size:20px; font-weight:700; margin-bottom:24px; }
    nav { display:flex; flex-direction:column; gap:8px; }
    a { color:#d1d5db; text-decoration:none; padding:10px 12px; border-radius:8px; }
    a.active, a:hover { background:#374151; color:#fff; }
  `]
})
export class SidebarComponent {
  readonly i18n = inject(I18nService);
}
